<template>
  <div class="Typeahead">
    <input
      type="text"
      md-inline
      class="autocompleteE"
      :placeholder="config.placeholder_value"
      autocomplete="off"
      v-model="query"
      @keydown.down="down"
      @keydown.up="up"
      @keydown.esc="reset"
      @blur="reset"
      @input="update"
    >

    <ul v-if="hasItems" style="color:black; min-width: 90%;">
      <li
        v-for="(item, index) in items"
        :key="item._id"
        :class="activeClass(index)"
        @mousemove="setActive(index)"
        @mousedown="hit"
      >
        <div align="left" v-if="items.length > 0">
          <small>{{(item)?item[config.principalAtribute]: 'sin registros'}}</small>

          <br v-if="config.secondaryAtribute != ''">
          <small
            v-if="config.secondaryAtribute != ''"
            style="color:blue;"
          >{{(item[config.secondaryAtribute])?item[config.secondaryAtribute]: 'Empty'}}</small>
          
          <small
            v-if="config.optionalMultipleAtribute != ''"
            class="pull-right"
            style="color:gray;"
          >{{(item[config.optionalMultipleAtribute[1]])?item[config.optionalMultipleAtribute[1]][config.optionalMultipleAtribute[2]]:'Empty'}}</small>
        </div>
      </li>
    </ul>

    <ul v-if="(!hasItems) && typeCheck" v-show="showEmpty" style="color:black; min-width: 90%;">
      <li v-if="loading">
        <center>
          <md-progress-spinner
            class="md-accent"
            style="color: #fafafa !important;"
            md-mode="indeterminate"
            :md-stroke="3"
          ></md-progress-spinner>
          <br>
          <small>Buscando...</small>
        </center>
      </li>
      <li v-else @mousedown="onEmpty">
        <center>
          <small>Sin registros para "{{query}}"</small>
          <br>
          <small style="color:blue;">¿Crear como nuevo?</small>
        </center>
      </li>
    </ul>
  </div>
</template>



<script>
import VueTypeahead from './main.js'
// import api_routes from '../../../../config/api.js'

export default {
  extends: VueTypeahead,

  props:{
    config:{},
  },

  data () {
    return {
      src: '',
      limit: 5,
      minChars: 2,
      showEmpty: true,
      valueName: null,
      local_data: null,
      selectedOpt: null
    }
  },

  methods: {
    onHit (item) {
        let params =  {name: this.config.res_name, value: item}

        this.showEmpty = false;
        this.$emit('clickOnItem', params)
        this.selectedOpt = item.name;
    },
    onEmpty () {
     this.showEmpty = false;
     this.$emit('clickOnCreate', this.query)     
    },

    
    
  },
  
  mounted(){
    this.local_data = this.config;
    this.src = this.config.searchRoute;
    this.query = this.config.initialValue;
  },
   watch:{
     local_data: function (val, oldVal) {
      this.query = this.local_data.initialValue
     },
     selectedOpt(val){
       this.query = val;
     }
   
   }
}
</script>



<style scoped>
.Typeahead {
  position: relative;
}



.fa-times {
  cursor: pointer;
}

i {
  float: right;
  position: relative;
  top: 30px;
  right: 29px;
  opacity: 0.4;
}

ul {
  position: absolute;
  padding: 0;
  margin-top: 8px;
  min-width: 100%;
  background-color: #fff;
  list-style: none;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0,0,0, 0.25);
  z-index: 1000;
}

li {
  padding: 10px 16px;
  cursor: pointer;
}

li:first-child {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

li:last-child {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom: 0;
}

span {
  display: block;
  color: #2c3e50;
}

.active {
  background-color: #3aa373;
}

.active span {
  color: white;
}

.name {
  font-weight: 700;
  font-size: 18px;
}

.screen-name {
  font-style: italic;
}
</style>
